export type FlightsSearchUrlModel = {
  fromIata: string;
  toIata: string;
  departureDate: string;
  returnDate?: string;
  popular?: boolean;
  datesChanged?: boolean;
};

/**
 * Creates basic roundtrip flight search URL.
 *
 * @param data data for flights search.
 * @param caSource tracking source.
 * @param location location object with search params.
 * @returns roundtrip search url.
 */
export function getRoundtripSearchUrl(
  data: FlightsSearchUrlModel,
  caSource: string,
  prevSearchParams?: string
): string {
  const searchParams = new URLSearchParams(prevSearchParams);
  searchParams.set("type", "ROUNDTRIP");
  searchParams.set("adults", "1");
  searchParams.set("cabinClass", "ECONOMY");
  searchParams.set("sort", "BEST");
  searchParams.set("depart", data.departureDate);
  searchParams.set("from", data.fromIata);
  searchParams.set("to", data.toIata);

  if (data.returnDate) searchParams.set("return", data.returnDate);
  if (data.popular) searchParams.set("popular", "1");
  if (data.datesChanged === false) searchParams.set("open_datepicker", "1");

  return `/flights/${data.fromIata}-${data.toIata}/?${searchParams.toString()}&ca_source=${caSource}`;
}

/**
 * Creates basic roundtrip flight search URL.
 *
 * @param data data for flights search.
 * @param caSource tracking source.
 * @param location location object with search params.
 * @returns roundtrip search url.
 */
export function getOnewaySearchUrl(data: FlightsSearchUrlModel, caSource: string, prevSearchParams?: string): string {
  const searchParams = new URLSearchParams(prevSearchParams);
  searchParams.set("type", "ONEWAY");
  searchParams.set("adults", "1");
  searchParams.set("cabinClass", "ECONOMY");
  searchParams.set("sort", "BEST");
  searchParams.set("from", data.fromIata);
  searchParams.set("to", data.toIata);
  if (data.departureDate) searchParams.set("depart", data.departureDate);
  if (data.popular) searchParams.set("popular", "1");
  if (data.datesChanged === false) searchParams.set("open_datepicker", "1");

  return `/flights/${data.fromIata}-${data.toIata}/?${searchParams.toString()}&ca_source=${caSource}`;
}
